export default function TitleBar() {
  return (
    <header className="relative w-full border-b border-b-black bg-gray-200 py-2">
      <section className="mx-auto max-w-[85rem]">
        <h2 className="text-center font-serif text-[110%] font-bold italic md:text-xl">
          Emergency Vehicle Technician Certification Commission
        </h2>
      </section>
    </header>
  );
}
